<div class="geofence-card">
  <app-base-card>
    @let previewUrl = mapPreviewUrl();
    @if (previewUrl && !previewFailed()) {
      <img
        class="map-preview"
        alt="Map preview of {{ geofence().name }}"
        loading="lazy"
        [src]="previewUrl"
        (error)="previewFailed.set(true)"
      />
    }

    <div class="header-title">{{ geofence().name }}</div>

    <div class="chip-row">
      @for (type of availableTypes(); track type.kind) {
        <p-tag [value]="type.label" [style]="{ 'background-color': GeofenceKindColor[type.kind], color: 'white' }" />
      }
    </div>

    <div class="meta-row">
      <i class="pi pi-calendar"></i>
      Created on {{ geofence().createdDate | date: 'shortDate' }}
    </div>
    <div class="meta-row">
      <i class="pi pi-calendar"></i>
      Last Updated {{ geofence().updatedDate | date: 'shortDate' }}
    </div>

    <div class="button-row">
      <button
        pButton
        label="Delete"
        severity="secondary"
        [rounded]="true"
        [loading]="isDeleting()"
        (click)="deleteGroup()"
      ></button>
      <button pButton label="View Details" severity="primary" [rounded]="true" (click)="viewGeofenceDetails()"></button>
    </div>
  </app-base-card>
</div>
